const PHONE_REGEX = /^(\+?\d{1,4}[\s-]?)?(\(\d{1,3}\))?[\s-]?\d{1,4}[\s-]?\d{1,4}[\s-]?\d{1,9}$/;

const PHONE_REGEX_STRICT = /^\+[1-9]{1}[0-9]{3,14}$/;

export { PHONE_REGEX, PHONE_REGEX_STRICT };
